import Image from 'next/image';

// Spot illustrations are always 120x120 and decorative — EmptyState already wraps
// the icon slot in aria-hidden, so the empty alt keeps it out of the a11y tree.
const SPOT_ILLUSTRATION_SIZE = 120;

type SpotIllustrationProps = {
  src: string;
};

const SpotIllustration = ({ src }: SpotIllustrationProps) => (
  <Image
    src={src}
    alt=""
    role="presentation"
    width={SPOT_ILLUSTRATION_SIZE}
    height={SPOT_ILLUSTRATION_SIZE}
    data-testid="SpotIllustration"
  />
);

export default SpotIllustration;
